import React from 'react';
import styled, { css } from 'styled-components';
import { Tooltip } from './Tooltip';
const ChipWrapper = styled.div `
  --chip-background: ${({ theme }) => theme.style.chipDefaultBackgroundColor};
  --chip-color: ${({ theme }) => theme.style.chipDefaultTextColor};
  --chip-font-weight: ${({ theme }) => theme.style.chipDefaultFontWeight};
  --chip-font-size: ${({ theme }) => theme.style.chipDefaultFontSize};
  --chip-border-properties: ${({ theme }) => theme.style.chipDefaultBorderProperties};
  --chip-border-width: ${({ theme }) => theme.style.chipDefaultBorderWidth};
  --chip-border-color: ${({ theme }) => theme.style.chipDefaultBorderColor};
  --chip-border-radius: ${({ theme }) => theme.style.chipDefaultBorderRadius};

  display: flex;
  width: fit-content;
  max-width: 100%;
  max-height: fit-content;
  align-items: center;
  color: var(--chip-color);
  background-color: var(--chip-background);
  box-shadow: var(--chip-border-properties) var(--chip-border-width) var(--chip-border-color);
  border-radius: var(--chip-border-radius);
  font-weight: var(--chip-font-weight);
  font-size: var(--chip-font-size);

  svg {
    --icon-color: currentColor;
    --icon-size: ${({ theme }) => theme.style.chipDefaultIconSize};
  }

  ${({ counter }) => typeof counter === 'undefined' &&
    css `
      gap: ${({ theme }) => theme.style.chipDefaultGap};
      padding: ${({ theme }) => theme.style.chipDefaultPadding};
    `}

  ${({ counter }) => typeof counter !== 'undefined' &&
    css `
      gap: ${({ theme }) => theme.style.chipDefaultCounterGap};
      font-weight: var(--chip-font-weight);
      font-size: ${({ theme }) => theme.style.chipDefaultFontSize};
      box-shadow: none;
      border-radius: 0;
      background: none;
    `}

  ${({ type }) => type === 'success' &&
    css `
      --chip-background: ${({ theme }) => theme.style.chipSuccessBackgroundColor};
      --chip-color: ${({ theme }) => theme.style.chipSuccessTextColor};
      --chip-border-color: ${({ theme }) => theme.style.chipSuccessBorderColor};
    `}
  ${({ type }) => type === 'warning' &&
    css `
      --chip-background: ${({ theme }) => theme.style.chipWarningBackgroundColor};
      --chip-color: ${({ theme }) => theme.style.chipWarningTextColor};
      --chip-border-color: ${({ theme }) => theme.style.chipWarningBorderColor};
    `}
  ${({ type }) => type === 'danger' &&
    css `
      --chip-background: ${({ theme }) => theme.style.chipDangerBackgroundColor};
      --chip-color: ${({ theme }) => theme.style.chipDangerTextColor};
      --chip-border-color: ${({ theme }) => theme.style.chipDangerBorderColor};
    `}
  ${({ type }) => type === 'info' &&
    css `
      --chip-background: ${({ theme }) => theme.style.chipInfoBackgroundColor};
      --chip-color: ${({ theme }) => theme.style.chipInfoTextColor};
      --chip-border-color: ${({ theme }) => theme.style.chipInfoBorderColor};
    `}

  ${({ size }) => size === 'small' &&
    css `
      svg {
        --icon-size: ${({ theme }) => theme.style.chipSmallIconSize};
      }

      ${({ counter }) => typeof counter === 'undefined' &&
        css `
          gap: ${({ theme }) => theme.style.chipSmallGap};
          padding: ${({ theme }) => theme.style.chipSmallPadding};
          border-radius: ${({ theme }) => theme.style.chipSmallBorderRadius};
          font-size: ${({ theme }) => theme.style.chipSmallFontSize};

          svg {
            margin-left: -2px;
          }
        `}

      ${({ counter }) => typeof counter !== 'undefined' &&
        css `
          gap: ${({ theme }) => theme.style.chipSmallCounterGap};
          font-size: ${({ theme }) => theme.style.chipSmallFontSize};
        `}
    `}

    ${({ size }) => size === 'large' &&
    css `
      svg {
        --icon-size: ${({ theme }) => theme.style.chipLargeIconSize};
      }

      ${({ counter }) => typeof counter === 'undefined' &&
        css `
          gap: ${({ theme }) => theme.style.chipLargeGap};
          padding: ${({ theme }) => theme.style.chipLargePadding};
          border-radius: ${({ theme }) => theme.style.chipLargeBorderRadius};
          font-size: ${({ theme }) => theme.style.chipLargeFontSize};

          svg {
            margin-left: -2px;
          }
        `}

      ${({ counter }) => typeof counter !== 'undefined' &&
        css `
          gap: ${({ theme }) => theme.style.chipLargeCounterGap};
          font-size: ${({ theme }) => theme.style.chipLargeFontSize};
        `}
    `}
`;
const Label = styled.div `
  line-height: 16px;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;

  ${({ size }) => size === 'small' &&
    css `
      line-height: ${({ theme }) => theme.style.chipSmallFontSize};
    `}
`;
const Counter = styled.div `
  min-width: 12px;
  padding: ${({ theme }) => theme.style.chipDefaultCounterPadding};
  line-height: var(--chip-font-size);
  background-color: var(--chip-background);
  box-shadow: var(--chip-border-properties) var(--chip-border-width) var(--chip-border-color);
  border-radius: var(--chip-border-radius);
  font-weight: var(--chip-font-weight);
  font-size: var(--chip-font-size);
  text-align: center;

  ${({ size }) => size === 'small' &&
    css `
      --chip-font-size: ${({ theme }) => theme.style.chipSmallFontSize};
      padding: ${({ theme }) => theme.style.chipSmallCounterPadding};
      border-radius: ${({ theme }) => theme.style.chipSmallCounterBorderRadius};
    `}
`;
const ChipTooltip = ({ tooltip, children }) => {
    return (!!tooltip ? React.createElement(Tooltip, { ...tooltip }, children) : children);
};
export const Chip = ({ type, counter, size, icon, className, tooltip, children }) => {
    const styleProps = {
        type: type ?? 'default',
        size: size ?? 'default',
        counter,
    };
    return (React.createElement(ChipTooltip, { tooltip: tooltip },
        React.createElement(ChipWrapper, { className: !!tooltip ? undefined : className, ...styleProps },
            typeof styleProps.counter !== 'undefined' && (React.createElement(Counter, { ...styleProps, key: counter }, counter)),
            icon,
            React.createElement(Label, { ...styleProps }, children))));
};
//# sourceMappingURL=Chip.js.map